import React from 'react';
import { Row, Col, Card, Skeleton } from 'antd';

/** Skeleton loading state that matches dashboard layout to prevent layout shift */
export const DashboardSkeleton: React.FC = () => {
  return (
    <div className="dashboard-skeleton">
      {/* Header skeleton */}
      <div className="dashboard-section dashboard-header-skeleton">
        <Skeleton.Input active size="large" style={{ width: 220 }} />
        <Skeleton.Button active style={{ width: 180, height: 36 }} />
      </div>

      {/* KPI cards skeleton */}
      <section className="dashboard-section">
        <Row gutter={[24, 24]}>
          {[1, 2, 3, 4].map(i => (
            <Col xs={24} sm={12} lg={6} key={i}>
              <Card className="dashboard-skeleton-card">
                <div className="dashboard-skeleton-card-inner">
                  <Skeleton.Avatar
                    active
                    size={40}
                    shape="square"
                    style={{ borderRadius: 12 }}
                  />
                  <Skeleton.Input
                    active
                    size="small"
                    style={{ width: 80, marginTop: 16 }}
                  />
                  <Skeleton.Input
                    active
                    size="large"
                    style={{ width: 120, marginTop: 8 }}
                  />
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </section>

      {/* Analytics skeleton */}
      <section className="dashboard-section">
        <Row gutter={[24, 24]}>
          <Col xs={24} lg={12}>
            <Card className="dashboard-skeleton-card dashboard-skeleton-chart">
              <Skeleton.Input active size="small" style={{ width: 140 }} />
              <Skeleton.Input
                active
                size="small"
                style={{ width: 100, marginTop: 4 }}
              />
              <Skeleton
                active
                paragraph={{ rows: 6 }}
                style={{ marginTop: 24 }}
              />
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card className="dashboard-skeleton-card dashboard-skeleton-categories">
              <Skeleton.Input active size="small" style={{ width: 140 }} />
              <Skeleton.Input
                active
                size="small"
                style={{ width: 100, marginTop: 4 }}
              />
              <Skeleton
                active
                paragraph={{ rows: 5 }}
                style={{ marginTop: 24 }}
              />
            </Card>
          </Col>
        </Row>
      </section>

      {/* Recent activity skeleton */}
      <section className="dashboard-section">
        <Card className="dashboard-skeleton-card">
          <Skeleton.Input active size="small" style={{ width: 160 }} />
          <Skeleton.Input
            active
            size="small"
            style={{ width: 200, marginTop: 4 }}
          />
          <Skeleton active paragraph={{ rows: 5 }} style={{ marginTop: 24 }} />
        </Card>
      </section>
    </div>
  );
};
